export { default } from "./teacherToolsAndAutoGenWritePrompts";
